import { AxiosResponse } from 'axios';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { KitItem } from '../../api/types';
import { SimplyTestApi } from '../../api/simplytest';
import { selectConfig } from '../../shared/redux/slice';
import { IConfiguration } from '../../shared/types';
import { selectIdToken, unauthorized } from '../../auth/redux/slice';
import { toast } from 'react-hot-toast';
import kitsSlice, { loadKit, loadKits } from './slice';

export abstract class KitsSagas {
    public static* run(){
        try {
            yield all([
                takeLatest(loadKits, KitsSagas.loadKits),
                takeLatest(loadKit, KitsSagas.loadKit),
            ]);
        }
        catch(e: any){
            console.log(`[KitsSagas:run] the following exception has occurred`, e);
        }
    }

    private static* loadKits(action: ReturnType<typeof loadKits>){
        try {
            yield put(kitsSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            const { payload } = action;

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const kitsResponse: AxiosResponse<KitItem[]> = yield call(
                { context: client, fn: client.searchKits },
                { status: payload.status },
            );

            if(kitsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(kitsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(kitsSlice.actions.setKits(kitsResponse.data));
            yield put(kitsSlice.actions.setState('READY'));
        }
        catch(e: any){
            yield put(kitsSlice.actions.setState('ERROR'));
            toast.error('Error Loading Kits');
            console.log(`[KitsSagas:loadKits] the following exception has occurred`, e);
        }
    }

    private static* loadKit(action: ReturnType<typeof loadKit>){
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            const { payload } = action;

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const kitResponse: AxiosResponse<KitItem> = yield call(
                { context: client, fn: client.getKit },
                payload.kitId,
            );

            if(kitResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(kitResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(kitsSlice.actions.setSelectedKit(kitResponse.data));
        }
        catch(e: any){
            toast.error('Error Loading Kit');
            console.log(`[KitsSagas:loadKit] the following exception has occurred`, e);
        }
    }
}
